// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { ERROR_CODE_MAPPING } from '@/api/constants';
import { errorResponseSchema } from '@/api/types';
import axios from 'axios';

/** Checks whether a request was refused by a free plan limit. */
export function isPlanLimitError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) {
    return false;
  }

  const result = errorResponseSchema.safeParse(error.response?.data);
  return (
    result.success &&
    result.data.metadata.errors.some(
      (responseError) =>
        responseError.statusCode === ERROR_CODE_MAPPING.plan_limit_exceeded
    )
  );
}
